<div class="container">
  <div class="testi-popup">
    <h1 mat-dialog-title>{{testimonialData.title}}
      <button mat-button class="btn map-close btn-light btn-close btn-close1 " (click)="closeDialog()"></button>
    </h1>

    <mat-dialog-content class="mat-typography">
      <div class="testi-popup__descrp">
        <p [innerHtml]="testimonialData.description"></p>
        <img [src]="testimonialData.image" class="img-box" alt="">
      </div>
   </mat-dialog-content>

    <mat-dialog-actions align="end">
      <p>Tour - {{testimonialData.tourname}}</p>
    </mat-dialog-actions>
  </div>

  <div class="img-box">
   
  </div>
</div>

<!-- <h2 mat-dialog-title>{{testimonialData.title}} <button mat-button class="btn map-close btn-light btn-close" (click)="closeDialog()"></button></h2>
<mat-dialog-content class="mat-typography">
  <p [innerHtml]="testimonialData.description"></p>
  <img [src]="testimonialData.image" alt="">
</mat-dialog-content>
<mat-dialog-actions align="end">
  <p>Tour - {{testimonialData.tourname}}</p>
</mat-dialog-actions> -->